import { ChangeEvent, FC, ReactNode, useMemo } from "react";
// styles
import styles from "../styles/Slider.module.css";
// interface

interface ISlider {
  question: string;
  min: number;
  max:number;
  step?:number;
  range: number;
  setRange: (range: number) => void;
  rightCorner?: React.ReactElement;
  renderValue?: (range: number) => ReactNode;
}

const Slider: FC<ISlider> = ({
  range,
  setRange,
  question,
  min,max,step,
  rightCorner,
  renderValue
}) => {

  const onChange = (ev: ChangeEvent<HTMLInputElement>) => {
    setRange(Number(ev.target.value));
  };

  const renderedValue = useMemo(() => renderValue ? renderValue(range) : range.toString(), [range, renderValue])

  return (
    <div className={styles.sliderWrapper}>
      <div className={styles.labelWrapper}>
        <p className={`${styles.text} ${styles.bold}`}>
          <span>{question}{' '}</span>
          <span  className={styles.sliderValue}>
            <span>{renderedValue}</span>
          </span>
        </p>
        <p className={styles.text}>
          {rightCorner}
        </p>
      </div>
      <div className={styles.slider}>
        <input
          type="range"
          id="range"
          min={min}
          max={max}
          value={range}
          step={step || 1}
          onChange={onChange}
          className={styles.input}
        />

      </div>
    </div>
  );
};

export default Slider;
